module.exports = __webpack_public_path__ + "json/cloudwords.json?5ac29e806f9ffcd3157734007f234baa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/cloudwords.json
// module id = 273
// module chunks = 0